import { create } from "zustand";
import { persist } from "zustand/middleware";
import { LS_MEMO_VIEW_STORAGE } from "../shared/local-storage/keys";

type TMemoViewStore = {
  isFullWidth: boolean;
  isRawView: boolean;
  setFullWidth: (value: boolean) => void;
  toggleFullWidth: () => void;
  setRawView: (value: boolean) => void;
};

export const useMemoViewStore = create<TMemoViewStore>()(
  persist(
    (set) => ({
      isFullWidth: false,
      isRawView: false,
      setFullWidth: (value) => set({ isFullWidth: value }),
      toggleFullWidth: () => set((state) => ({ isFullWidth: !state.isFullWidth })),
      setRawView: (value) => set({ isRawView: value })
    }),
    {
      name: LS_MEMO_VIEW_STORAGE,
      partialize: (state) => ({ isFullWidth: state.isFullWidth })
    }
  )
);
